// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2688":"52f1b461","5221":"0ea0933c"}[chunkId] + ".chunk.css";
};